// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__15C_E","title":"Images45_title__1tZaN","images":"Images45_images__3PDNF"};